import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from './ui';
import './GroupTabs.css';

/**
 * Вкладки процесса над страницей (меню по процессам, решение владельца 26.09).
 *
 * Пункт меню «Приёмка» = вкладки «Приёмки · Забор · Возвраты ПВЗ»; каждая
 * вкладка — прежний экран по прежнему адресу. Рисует Layout по конфигу меню
 * (navConfig.js), страницы про эту полосу не знают.
 *
 * Выглядит как навигация, а не как вкладки страницы: название процесса слева и
 * сегментный переключатель на подложке. У многих экранов свои вкладки (линия
 * снизу) и фильтры-таблетки — два одинаковых ряда путали бы.
 */
export default function GroupTabs({ entry }) {
  const location = useLocation();
  const navigate = useNavigate();
  const ref = useRef(null);
  const active = entry ? entry.tabs.find(t => t.path.split('?')[0] === location.pathname) : null;
  // Узкий экран (ТСД 360): вкладки прокручиваются вбок — открытую держим в
  // видимой части, иначе «Хвосты» оказывались за краем и казалось, что их нет.
  // Прокручиваем только сам ряд вкладок, не страницу.
  const activeKey = active ? active.path : null;
  useEffect(() => {
    const row = ref.current && ref.current.querySelector('.ui-tabs');
    const btn = row && row.querySelector('.ui-tabs__item--active');
    if (!row || !btn || row.scrollWidth <= row.clientWidth) return;
    const left = btn.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft;
    row.scrollLeft = left - (row.clientWidth - btn.offsetWidth) / 2;
  }, [activeKey]);
  if (!entry || entry.tabs.length < 2) return null;
  const Icon = entry.icon;
  return (
    <nav ref={ref} className="group-tabs" aria-label={`Раздел «${entry.label}»`}>
      <span className="group-tabs__title">
        {Icon && <Icon size={15} aria-hidden="true" />}
        <span>{entry.label}</span>
      </span>
      <Tabs
        className="group-tabs__tabs"
        variant="pills"
        size="sm"
        aria-label={entry.label}
        tabs={entry.tabs.map(t => ({ key: t.path, label: t.label, title: t.hint }))}
        activeKey={active ? active.path : null}
        onChange={(path) => { if (!active || path !== active.path) navigate(path); }}
      />
    </nav>
  );
}
